"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var PlusIcon_1 = __importDefault(require("mdi-react/PlusIcon"));
var material_1 = require("@mui/material");
var AddRowButton = function (_a) {
    var currentTableObj = _a.currentTableObj, t = _a.t;
    return (react_1.default.createElement(material_1.Tooltip, { title: t('contents.widgets.table.addDataRow') },
        react_1.default.createElement(material_1.Button, { style: {
                marginTop: '5px',
                backgroundColor: '#fafafa',
                color: 'black',
                fontSize: 'initial',
                textAlign: 'initial',
                lineHeight: 'initial',
                letterSpacing: 'initial'
            }, size: 'small', variant: 'outlined', onClick: function () { return currentTableObj === null || currentTableObj === void 0 ? void 0 : currentTableObj.addRow(); } },
            react_1.default.createElement(PlusIcon_1.default, { id: 'table-add-row' }))));
};
exports.default = AddRowButton;
//# sourceMappingURL=AddRowButton.js.map